"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            maxWidth: '100%',
            position: 'relative',
        },
        rootDisabled: {
            opacity: 0.5,
        },
        rootNormal: {
            minWidth: 260,
        },
        noPadding: {
            padding: '0px 16px 0px 0px !important',
        },
        selectRootSmall: {
            '&:before': {
                display: 'none',
            },
        },
        errorContainer: {
            marginTop: 3,
            minHeight: 16,
            marginBottom: -16,
        },
        errorText: {},
        helperText: {
            padding: '8px 24px 8px 24px',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            background: 'white',
        },
        menuList: {
            padding: '8px 0px !important',
        },
        selectMenu: {
            '&:focus': {
                backgroundColor: 'inherit !important',
            },
        },
        menuPaper: {
            marginTop: 4,
            borderRadius: 4,
            boxShadow: theme_1.default.shadows.strong,
        },
        iconSmall: {
            color: theme_1.default.textColors.primary,
            top: 7,
        },
        icon: {
            color: "".concat(theme_1.default.textColors.primary, " !important"),
            top: 2,
            marginRight: 8,
        },
        iconOpen: {
            transform: 'rotate(180deg) !important',
        },
        focused: {
            '&::after': {
                backgroundColor: theme_1.default.colors.primary,
            },
        },
        noFocus: {
            '&::after': {
                display: 'none',
            },
        },
        errorFocused: {
            '&::after': {
                backgroundColor: theme_1.default.colors.error,
            },
        },
        underline: {
            '&:before, &:after': {
                border: 'none !important',
                height: 2,
                borderRadius: 4,
            },
            '&:before': {
                backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.dark, 0.08),
            },
            '&:hover:before': {
                backgroundColor: theme_1.default.textColors.primaryLight,
            },
        },
        errorUnderline: {
            '&:before, &:after': {
                border: 'none !important',
                height: 2,
                borderRadius: 4,
            },
            '&:before': {
                backgroundColor: theme_1.default.colors.error,
            },
            '&:hover:before': {
                backgroundColor: theme_1.default.textColors.error,
            },
        },
        disabledUnderline: {
            pointerEvents: 'none',
        },
        inputRoot: {
            width: '100%',
        },
        input: function (_a) {
            var fontVariant = _a.fontVariant;
            return (__assign(__assign({}, theme_1.default.fonts[fontVariant]), { color: theme_1.default.textColors.primary, minHeight: theme_1.default.fonts[fontVariant].lineHeight, padding: '0px 0px 4px 0px' }));
        },
    });
});
